<template>
	<div>
		<div @click="godetail(data)" class="item padding-bottom-sm padding-lr margin-bottom-sm flex justify-between align-center">
			<p class="text-cut-2 title text-left text-bold fu-fs24">{{data.title}}</p>
			<div class="">
				<p class="text-price text-prices fu-fs24 text-bold">{{data.price}}</p>
				<p class="text-999 text-xs">费用预算</p>
			</div>
			
			<div v-if="data.status == 1" class="sticky btn2 text-center fu-fs26">审核中</div>
			<div v-if="data.status == 2" class="sticky btn3 text-center fu-fs26">未通过</div>
			<div v-if="data.status == 3" class="sticky btn1 text-center fu-fs26">已发布</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
	  props: {
	    width: {
	      type: [String,Number],
	      default:387
	    },
	    height:{
	    	type: [String,Number],
	    	default:168
	    },
		size:{//标题字体
			type: [String,Number],
			default:18
		},
		data:{
			type: Object,
			default:{}
		}
	  },
	  mounted(){
	    
	  },
	  methods: {
	    godetail(data){
			
	    	this.$emit('godetail',data)
			
	    }
	  }
	};
</script>

<style scoped lang="less">
	.item{
		// width: 387px;
		// height: 168px;
		background: #FFFFFF;
		padding-top: 40px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 20px;
		position: relative;
		.title{
			max-width: 600px;
			
		}
		.fu-fs24{
			font-size: 24px;
		}
		.block-63{
			width: 36px;
			height: 36px;
			border-radius: 50%;
		}
		.block-15{
			width: 15px;
			height: 15px;
		}
		.add{
			width: 16px;
			height: 19px;
		}
		.margin-left-8{
			margin-left: 8px;
		}
		.sticky{
			position: absolute;
			top: 0;
			right: 0;
			width: 62px;
			height: 24px;
			font-size: 13px;
			line-height: 24px;
			border-radius: 0px 20px 0px 0px;
		}
		.btn1{
			background: rgba(11, 131, 124, 0.1);
			color: #0B837C;
		}
		.btn2{
			background: #FEF5E9;
			color: #FAA74F;
		}
		.btn3{
			background: #EAF0FC;
			color: #568EEB;
		}
		.tip-item{
			font-size: 13px;
			padding: 5px 10px;
			border-radius: 12px;
			background: #F1F1F1;
			margin-right: 9px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/list/administer-list.vue